export * from './logger';
export * from './config';

export function between(estimatedAmount: number, lowerLimit: number, maxLimit: number) {
    return estimatedAmount >= lowerLimit && estimatedAmount <= maxLimit;
}
